module.exports = __webpack_public_path__ + "static/media/electric_bg_1.ce695806.jpg";